import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { materialsActions } from '../actions/materials.actions';
import { selectLoaded, selectLoading, selectLookupLoaded, selectLookupOptions, selectMaterials, selectTotal } from '../selectors/materials.selector';

@Service()
export class MaterialsFacade {
    private readonly store = inject(Store);

    readonly materials = this.store.selectSignal(selectMaterials);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly total = this.store.selectSignal(selectTotal);
    readonly lookupLoaded = this.store.selectSignal(selectLookupLoaded);
    readonly lookupOptions = this.store.selectSignal(selectLookupOptions);

    getMaterials(page: number, limit: number): void {
        this.store.dispatch(materialsActions.getMaterials({ value: { page, limit } }));
    }

    getMaterialsLookup(): void {
        this.store.dispatch(materialsActions.getMaterialsLookup());
    }

    clear(): void {
        this.store.dispatch(materialsActions.clear());
    }
}
